export default __webpack_public_path__ + "ui/assets/img/balance-grey-16.svg";